<div class="card" [ngClass]="{ info: !title || !!titleOnly }">
  <img
    [width]="imgWidth"
    [height]="imgHeight"
    [src]="typeIconRoute"
    *ngIf="type !== 'none'"
  />

  <div class="text">
    <h1 *ngIf="title">
      <strong>{{ title }}</strong>
    </h1>

    <div [innerHTML]="content"></div>
    <ng-content></ng-content>
  </div>
</div>
